import { render, staticRenderFns } from "./CourseApplicationWrapper.vue?vue&type=template&id=035843d3"
import script from "./CourseApplicationWrapper.vue?vue&type=script&lang=js"
export * from "./CourseApplicationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports